<template>
    <Dialog v-model:visible="visible" modal :header="$t('diamond_dialogue.title')"
        :breakpoints="{ '1199px': '75vw', '575px': '90vw' }" :style="{ width: '50vw' }">
        <h2>{{ $t('diamond_dialogue.h2') }}</h2>
        <span class="text-surface-500 dark:text-surface-400 block mb-3">{{ $t('diamond_dialogue.select_plan') }}</span>

        <Carousel :value="getProducts" :numVisible="3" :numScroll="1" :responsiveOptions="responsiveOptions"
            :showIndicators="false">
            <template #item="slotProps">
                <div class="border border-surface-200 dark:border-surface-700 rounded m-2  p-4 item"
                    @click="selectedProduct = slotProps.index"
                    :class="{ 'selected': selectedProduct == slotProps.index }">
                    <span class="material-symbols-outlined checkedIcon" v-if="selectedProduct == slotProps.index" translate="no">
                        check_circle
                    </span>
                    <div class="mb-4">
                        <div class="relative mx-auto">
                            <h1>{{ slotProps.data.title }}</h1>
                            <span class="label">{{ slotProps.data.label }}</span>
                        </div>
                    </div>
                    <div class="mb-4 font-medium">{{ slotProps.data.price }}</div>
                    <div class="mb-4"></div>
                </div>
            </template>
        </Carousel>

        <template #footer>
            <Button id="startPayment" @click="startPayment()">
                <span class="product">{{ getSelectedProduct() }}</span>
                <span class="continue">{{ $t('diamond_dialogue.continue') }}</span>
            </Button>
        </template>
    </Dialog>
</template>

<script>
import axios from 'axios';

export default {
    name: "SubscriptionDialogRef",
    props: ['my_profile', 'products'],
    data() {
        return {
            visible: false,
            selectedProduct: 0,
            responsiveOptions: [
                {
                    breakpoint: '1400px',
                    numVisible: 3,
                    numScroll: 1
                },
                {
                    breakpoint: '1199px',
                    numVisible: 3,
                    numScroll: 1
                },
                {
                    breakpoint: '767px',
                    numVisible: 2,
                    numScroll: 1
                },
                {
                    breakpoint: '575px',
                    numVisible: 1,
                    numScroll: 1
                }
            ],
        }
    },
    computed: {
      getProducts() {
        return this.products.filter(product => product.product_type === 0);
      }
    },
    methods: {
        openDialog() {
            this.selectedProduct = 0;
            this.visible = true;
        },

        getSelectedProduct() {

            if (this.getProducts.length == 0) {
                return '';
            }
            const array = this.getProducts;
            return array[this.selectedProduct].title + ' with $' + array[this.selectedProduct].price
        },
        async startPayment() {
            const array = this.getProducts;

            try {
                const response = await axios.get(this.$socket_url + '/stripe/createLinkForSubscription/' + array[this.selectedProduct].gateway_product_id, {
                    headers: {
                        'Authorization': this.$socket.authKeyUnique.auth,
                    }
                });

                if (response.data.url) {
                    this.visible = false;

                    window.open(response.data.url, '_blank').focus();
                }
                console.log(response.data)
            } catch (error) {
                console.log(error);
            }

        }
    },
    watch: {
        selectedProduct(newValue) {
            console.log(newValue);
        }
    }
}
</script>

<style scoped>
.item {
    cursor: pointer;
    position: relative;
}

span.label {
    position: absolute;
    top: -20px;
    left: 0;
    color: rgb(174, 131, 12);
}

.checkedIcon {
    color: rgb(239 174 81);
    font-size: 30px;
    position: absolute;
    top: 20px;
    right: 20px;
}

h1 {
    font-size: large;
}

h2 {
    line-height: 34px;
    text-align: center;
}

#startPayment {
    background-image: var(--gradient--background-gold);
    width: 100%;
    outline-color: transparent;
    border: none;
    color: black;
    flex-direction: column;
}

button#startPayment span {
    display: block;
}

#startPayment span.product {
    font-size: 12px;
}

#startPayment span.continue {
    font-size: 20px;
    font-weight: 800;
}
</style>